import { Component } from 'react'
import { OperationStart, FullLoadingLayer } from 'stylewhere/components'
import { EncodingExtensions } from 'stylewhere/extensions'
import {
  Router,
  FormSchemaData,
  FormSchema,
  FormSchemaField,
  setFieldValue,
  OperationConfig,
  AppStore,
} from 'stylewhere/shared'
import { Places, TmrPlace } from 'stylewhere/api'
import { showToast, showToastError } from 'stylewhere/utils'
import { T, __ } from 'stylewhere/shared/i18n'
import { get as _get } from 'lodash'

interface State {
  loading: boolean
}

export default class EncodingOutboundSapStart extends Component<State> {
  state = {
    loading: false,
  }

  onSubmit = async (formData: FormSchemaData, operation: OperationConfig, schema: FormSchema) => {
    Router.navigate(
      '/encoding/encodingOutboundSap/:opCode/encode',
      { opCode: operation.code },
      { state: { formData: formData || {} } }
    )
  }

  render() {
    return (
      <OperationStart
        submitPath={'/encoding/encodingOutboundSap/:opCode/encode'}
        extensions={EncodingExtensions}
        onSubmit={this.onSubmit}
        formRowField
      />
    )
  }
}
